//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import {
  CampaignsMediaSort,
  ICampaignAutocompleteResponse,
  ICampaignMediaResponse,
  ICampaignMediaStats,
  ICampaignSearchRequestBody,
} from '@apis/campaigns/campaignsApiModel';
import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';

export interface ICampaignDetailsState extends ICampaignMedia {
  errors: {
    fetchAdditionalCampaignMediaError: string | undefined;
    fetchCampaignMediaError: string | undefined;
    fetchCampaignSearchAutocompleteError: string | undefined;
  };
  flags: {
    hasReachedEndOfCampaignMedia: boolean;
    isFetchingCampaignMedia: boolean;
    isFetchingAdditionalCampaignMedia: boolean;
    isFetchingCampaignSearchAutocompleteResults: boolean;
  };

  autocompleteResults: ICampaignAutocompleteResponse;
  dateRange: IAliasedDateRange | undefined;
  searchTerms: ICampaignSearchRequestBody;
  sort: CampaignsMediaSort;
}

export interface ICampaignMedia
  extends Omit<ICampaignMediaResponse, 'offset' | 'stats'> {
  searchOffset: number;
  stats: ICampaignMediaStats | undefined;
}

export interface ICampaignSearchTermData {
  term: string;
  type: 'hashtag' | 'username';
  prefix: '#' | '@';
}

export const CAMPAIGNS_MEDIA_REQUEST_LIMIT = 48;

export const DEFAULT_SEARCH_SORT_KEY = CampaignsMediaSort.VISUAL_SCORE;

export const CAMPAIGN_DETAILS_SORT_LABELS = {
  [CampaignsMediaSort.TIME]: 'Most Recent',
  [CampaignsMediaSort.LIKES]: 'Most Likes',
  [CampaignsMediaSort.COMMENTS]: 'Most Comments',
  [CampaignsMediaSort.VISUAL_SCORE]: 'Most On-Brand',
};
